var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingContainer',{attrs:{"is-loaded":_vm.isLoaded,"total":_vm.presetsLength,"kind":"Presets"}},[_c('ul',{staticClass:"activity-picker",attrs:{"slot":"default"},slot:"default"},[_vm._l((_vm.subjectPresets),function(p){return _c('li',{key:p.id},[_c('ColorButton',{staticClass:"activity-picker__button",attrs:{"color":_vm.subject.color,"tag":"router-link","to":{
          name: 'new-preset-activity',
          params: {
            presetId: p.id
          }
        }}},[_vm._v(" [Preset] "),_c('b',[_vm._v(_vm._s(p.description))])])],1)}),_c('li',[_c('ColorButton',{staticClass:"activity-picker__button",attrs:{"color":_vm.subject.color,"tag":"router-link","to":{
          name: 'new-custom-activity',
          params: {
            subjectId: _vm.subject.id
          }
        }}},[_vm._v(" Custom "),_c('b',[_vm._v(_vm._s(_vm.subject.name)+" Activity")])])],1)],2),_c('router-link',{staticClass:"button button--border",attrs:{"slot":"button","to":{
      name: 'settings-presets',
      query: {
        add: true
      }
    },"replace":""},slot:"button"},[_vm._v(" Add Preset ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }